import { Link, graphql, StaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import {
  NavItem, Dropdown, DropdownItem, DropdownToggle, DropdownMenu, Button,
  ButtonGroup, ButtonDropdown,
} from 'reactstrap';

import logo from '../../images/loc-event-91-logo.jpg';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      snipcartMenuOpen: false,
    };
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.toggleSnipcartMenu = this.toggleSnipcartMenu.bind(this);
  }

  componentDidMount() {
    document.addEventListener('snipcart.ready', () => {
      this.setState({ user: Snipcart.api.user.current() });
    });
    Snipcart.subscribe('authentication.success', () => {
      this.setState({ user: Snipcart.api.user.current() });
    });
    Snipcart.subscribe('user.loggedout', () => {
      this.setState({ user: null });
    });
  }

  toggleSnipcartMenu() {
    this.setState((prevState) => ({ snipcartMenuOpen: !prevState.snipcartMenuOpen }));
  }

  toggleDropdown(key) {
    this.setState((prevState) => ({ [key]: !prevState[key] }));
  }

  render() {
    const { data: { contentfulNavigation } } = this.props;
    const { user, snipcartMenuOpen } = this.state;
    return (
      <header className="site-header">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-4 align-self-center">
              <Link className="header-logo" to="/"><img src={logo} alt="header-logo" /></Link>
            </div>
            <div className="col-sm-12 col-md-8 align-self-center">
              <nav>
                <ul className="navbar-nav mr-auto">
                  {contentfulNavigation && contentfulNavigation.menuElement.map((element) => {
                    if (element.childElements) {
                      return (
                        <Dropdown
                          key={element.title}
                          nav
                          isOpen={this.state[element.slug]}
                          toggle={() => this.toggleDropdown(element.slug)}
                        >
                          <DropdownToggle nav caret>
                            {element.title}
                          </DropdownToggle>
                          <DropdownMenu>
                            {element.childElements.map((child) => (
                              <DropdownItem
                                key={child.title}
                              >
                                <Link
                                  className="nav-link nav-link-child"
                                  to={`${element.slug}/${child.slug || '/'}`}
                                >
                                  {child.title}
                                </Link>
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      );
                    }
                    return (
                      <NavItem key={element.title}>
                        <Link className="nav-link" to={`${element.slug || '/'}`}>{element.title}</Link>
                      </NavItem>
                    );
                  })}
                </ul>
                <ButtonGroup size="lg" className="nav-actions-wrapper nav-actions">
                  {user ? (
                    <ButtonDropdown isOpen={snipcartMenuOpen} toggle={this.toggleSnipcartMenu}>
                      <DropdownToggle size="lg">
                        <i className="fas fa-user" />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem header>Mon compte</DropdownItem>
                        <DropdownItem className="snipcart-summary snipcart-user-profile" to="#">
                        Mes
                        commandes
                        </DropdownItem>
                        <DropdownItem className="snipcart-summary snipcart-edit-profile" to="#">
                        Mes
                        informations
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem onClick={() => Snipcart.api.user.logout()}>
                        Se déconnecter
                        </DropdownItem>
                      </DropdownMenu>
                    </ButtonDropdown>
                  ) : (
                    <Button size="lg" className="nav-actions">
                      <Link
                        className="Header__summary snipcart-summary snipcart-edit-profile"
                        to="#"
                      >
                        <i className="fas fa-user" />
                      </Link>
                    </Button>
                  )}
                  <Button size="lg" className="nav-actions">
                    <Link className="Header__summary snipcart-summary snipcart-checkout" to="#">
                      <i className="fas fa-cart-plus" />
                    </Link>
                  </Button>
                </ButtonGroup>
              </nav>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  data: PropTypes.shape({
    contentfulNavigation: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      menuElement: PropTypes.arrayOf(PropTypes.shape({
        slug: PropTypes.string,
        title: PropTypes.string,
        childElements: PropTypes.arrayOf(PropTypes.shape({
          slug: PropTypes.string,
          title: PropTypes.string,
        })),
      })),
    }).isRequired,
  }).isRequired,
};

const Wrapper = (props) => (
  <StaticQuery
    query={graphql`
      query GetNavigation {
        contentfulNavigation(title: {eq: "Main Menu" }) {
          id
          title
          menuElement {
            slug
            title
            childElements {
              slug
              title
            }
          }
        }
      }
    `}
    render={(data) => <Header data={data} {...props} />}
  />
);

export default Wrapper;
